import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MessageService } from '@openng/optimus-ui/api';
import { captureException } from '@sentry/angular';

export function handleFlowError<T>(
  messageService: MessageService,
  displayMessage?: string,
): (source: Observable<T>) => Observable<T> {
  return (source: Observable<T>) =>
    source.pipe(
      catchError((error: Error) => {
        console.error(error);
        captureException(error);
        messageService.add({
          severity: 'error',
          summary: displayMessage ?? error.message,
        });
        return EMPTY;
      }),
    );
}
